// Spacebar production (app.spacebar.ai). pencilapp.com's prod environment with
// Spacebar's own hosts: its API at apis.spacebar.ai, and the services it shares with
// pencilapp.com (whiteboard, Galactus, Faye, PDF, signers) through apis.spacebar.ai's
// load balancer, which forwards them to prod's backends. Same Firebase project, so the
// same user accounts. Built with `ng build --configuration=spacebar`.
export const environment = {
  production: true,
  serverURL: 'https://apis.spacebar.ai/api',
  firebase: {
    apiKey: 'AIzaSyBrbpcXbAN7IwQNEUzfvyEJeu1T7Rch94Q',
    authDomain: 'app.spacebar.ai',
    databaseURL: 'https://pencil-frontend.firebaseio.com',
    projectId: 'pencil-frontend',
    storageBucket: 'pencil-frontend.appspot.com',
    messagingSenderId: '968454208069',
  },
  vapidPublicKey:
    'BCtK0nfXXgzpJarlI7MOR16j9xUN1eY9_5Y9zUQgFx7s51OfXH9A7rrAPMDzYtpMLJ7DrFAIXZUnD2FXo6rjAuk',
  sentryKey: 'https://ede17d29b50e449b8e253bb4e3fd759e@sentry.io/1501830',
  sentryOrganisationSlug: 'pencil',
  trainerUrl: 'https://teachertrainers.com',
  fullstoryOrgId: 'YQF1C',
  fayeServer: 'https://apis.spacebar.ai/faye',
  galactusServer: 'https://apis.spacebar.ai',
  whiteboardServer: 'https://apis.spacebar.ai/wb',
  dailyDomain: 'https://pncl.daily.co',
  gtmId: 'GTM-WNMQRX4',
  freshPaintKey: '265e0f64-e6fc-43ab-a9cb-a8a08a5b78d2',
  // Google sign-in, Drive import and YouTube all use Spacebar's own OAuth client
  // (Cloud project spacebar-prod-511302), so every consent screen says Spacebar.
  googleSignInClientId: '587978217589-8pmfufim12cris3b55c8bbgpofbm0rhk.apps.googleusercontent.com',
  youtube: {
    clientId: '587978217589-8pmfufim12cris3b55c8bbgpofbm0rhk.apps.googleusercontent.com',
  },
  drive: {
    clientId: '587978217589-8pmfufim12cris3b55c8bbgpofbm0rhk.apps.googleusercontent.com',
    developerKey: 'AIzaSyDeXP_K7zzWRTj1u0WqmFSOHVWvYH25m3A',
    scope: 'https://www.googleapis.com/auth/drive.file',
    // Project number of the Cloud project that owns clientId.
    appId: '587978217589',
  },
  chargebee: {
    site: 'pncl',
    publishableKey: 'live_5jfWO6PB2QZnabcdgiKJh1a5hgrxQBVbH',
  },
  onedrive: {
    clientId: '7b16c0dd-57dc-4636-b1f5-81f01bf031cf',
  },
  pexels: {
    apiKey: 'RHfXkCr8NALkFLm4ILQBuDFkMcgtjHJunn5ZJoZEgDCTgkBGe97EUVuH',
  },
  clever: {
    clientId: '4be4ab10c4e843523dff',
    redirectURI: 'https://clever-login-prod-hoigjxargq-uc.a.run.app',
  },
  classlink: {
    clientId: 'c1686507119175ae9faaa8b70a580dee04c2c9f3280d',
    redirectURI: 'https://classlink-login-prod-hoigjxargq-uc.a.run.app',
  },
  appScriptURL: 'https://pencilspaces.app.link/gcaladdon',
  thirdPartyEncryptionSalt: 'Dks983$%KDJS2#$!%567LKjdHDKJksjdwie_shaduE726##DHUASTsgaue',
  googleStorageBucketURL: 'https://storage.googleapis.com/pencil-frontend.appspot.com',
  firebaseAssetsPublicUrl: 'https://storage.googleapis.com/pencil-frontend.appspot.com/assets/',
  resizedImageUrlPattern:
    'https://firebasestorage.googleapis.com/v0/b/{bucket}/o/resized%2F{fileName}_{width}x{height}?alt=media&token={token}',
  convertedHeicWebpUrlPattern:
    'https://firebasestorage.googleapis.com/v0/b/{bucket}/o/converted%2F{base}.webp?alt=media&token={token}',
  resourceLibraryFolderName: 'resource_library_2/',
  firebaseMathematicsPath: 'mathematics/',
  firebasePhysicsPath: 'physics/',
  firebaseChemistryPath: 'chemistry/',
  firebaseLiteracyPath: 'literacy/',
  firebaseEmojisAndStickersPath: 'others/',
  firebaseBiologyPath: 'biology/',
  firebaseMusicPath: 'music/',
  resourceLibraryItemsFilePath: 'resource-library-items_3.json',
  phetSimulationsFileName: 'phet_simulations_items_with_categories_.json',
  phetSimulationsPreviewImagesPath: 'simulations_preview_images/',
  bioDigitalModelsFileName: 'bio_digital_items_1.json',
  bioDigitalModelsPreviewImagesPath: 'simulations_preview_images/',
  bioDigitalViewerUrl: 'https://human.biodigital.com/widget/?m={modelId}',
  svgSpriteName: 'sprite.6fe5a59a.svg',
  simulcastScreenShare: false,
  picassoServer: 'https://picasso.pencilapp.com:5001',
  marketingUrl: 'https://www.pencilspaces.com',
  oldPdfConverterServer: 'https://apis.spacebar.ai/pdf-converter',
  pdfConverterServer: 'https://apis.spacebar.ai/pdf-converter/convert-pdf-to-images',
  pdfConversionsFolder:
    'https://firebasestorage.googleapis.com/v0/b/pencil-frontend.appspot.com/o/pdf-conversions',
  useDailyScreenShareBalancedPreset: false,
  resourceSignerServer: 'https://apis.spacebar.ai/resource-signer',
  cdnResourcesSignerServer: 'https://apis.spacebar.ai/cdn-resources-signer',
  cdnResourcesDomain: 'https://resources.pencilapp.com',
  runServiceWorkerLocally: false,
  openAiServer: 'https://apis.spacebar.ai/pencil-ai-assistant',
  timeCheckServer: 'https://apis.spacebar.ai/timecheck',
  imageToLatexServer: 'https://apis.spacebar.ai/convertlatex',
  recordingTemplateOrigins: [
    'https://livekit-template.web.app',
    'https://livekit-template-staging.web.app',
  ],
  // Base URL of the mario-runner service that serves GENERATED apps from GCS.
  // Set per environment; GENERATED Mario apps require this to be configured.
  marioRunnerBaseUrl: 'https://apps.pencilapp.com',
  mcpOAuthCallbackOrigins: ['https://mcp.spacebar.ai'] as string[],
  // The agent's email address per space: SendGrid Inbound Parse, <tag>@agent.spacebar.ai.
  agentEmailDomain: 'agent.spacebar.ai',
  agentEmailPlusAddressing: false,
  // Spacebar's own legal pages, linked at sign-up and in settings.
  termsUrl: 'https://www.spacebar.ai/terms-of-service',
  privacyUrl: 'https://www.spacebar.ai/privacy-policy',
  // Organization admins see the AI data-use toggles (Settings > AI Assist > Data use), which
  // the privacy policy describes.
  aiDataUseSettings: true,
  // app.spacebar.ai is Spacebar: its theme is the default (an institution's own theme still wins).
  defaultTheme: 'spacebar',
  // Feature flags this build forces, over Optimizely. Optimizely decides per VIEWER (their
  // own institution), but these follow the SPACE: a guest from outside the institution
  // must see Sparky's call tile too, and with the flag off the call drops the agent.
  // spaces_switcher is the left-nav spaces list: still rolling out on pencilapp.com (prod
  // Optimizely has it on for internal users only), but part of Spacebar for everyone.
  forcedFeatureFlags: { enable_agent_join_call: true, spaces_switcher: true } as Record<
    string,
    boolean
  >,
};
